import FlowContainer from "../../components/FlowContainer";
import { AnalyticsTrackingEvent, brandclub_colors } from "@brandclub/common-ui";
import {
  ReviewDesc,
  ReviewInfo,
  ReviewQuestionContainer,
  ReviewSection,
  ReviewSummaryTitle,
  ReviewTitle,
} from "../components/ReviewStyledComponents";
import {
  FlowOutlineBorderButton,
  FlowSolidButton,
  FlowSolidButtonGrey,
} from "../../components/FlowButtons";
import FiveStarRating from "../components/FiveStarRating";

import { ButtonLoadingEllipsis } from "../../../../../StoreComponents/StoreButton";
import ProductHeader from "../components/ProductHeader";
import { Box } from "@mui/material";
import { FlowActionButtonsGroup } from "../../components/FlowStyledComponents";

const LOW_RATING_CAP = 2;

type SummaryProps = {
  product: any;
  title: string;
  reviewText: string;
  starRating: number;
  moveBack: () => void;
  moveNext: (e: "SUBMIT" | "SEND_TO_BRAND") => void;
  submitting: boolean;
  sending: boolean;
};

const Summary = ({
  product,
  title,
  reviewText,
  starRating,
  moveBack,
  moveNext,
  sending,
  submitting,
}: SummaryProps) => {
  const anySubmitting = sending || submitting;
  return (
    <FlowContainer style={{ background: brandclub_colors.white }}>
      <ReviewQuestionContainer>
        <ReviewInfo>
          <ProductHeader product={product} />
          <ReviewSection>
            <ReviewTitle>Confirm your product review.</ReviewTitle>
            <Box sx={{ margin: "35px 0 15px 0" }}>
              <FiveStarRating value={starRating} size={33} disabled />
            </Box>
            <ReviewSummaryTitle>{title}</ReviewSummaryTitle>
            <ReviewDesc>{reviewText}</ReviewDesc>
          </ReviewSection>
        </ReviewInfo>
        {starRating <= LOW_RATING_CAP ? (
          <FlowActionButtonsGroup>
            <Box sx={{ display: "flex", gap: "20px" }}>
              <FlowSolidButtonGrey
                sx={{ minWidth: "143px" }}
                disabled={anySubmitting}
                onClick={moveBack}
              >
                Back
              </FlowSolidButtonGrey>
              <FlowOutlineBorderButton
                trackedEventName={AnalyticsTrackingEvent.STARTED_SUBMIT_REVIEW}
                trackedAdditionalData={{
                  product,
                }}
                sx={{ minWidth: "143px" }}
                disabled={anySubmitting}
                onClick={() => {
                  moveNext("SUBMIT");
                }}
              >
                {submitting ? (
                  <>
                    Submitting
                    <ButtonLoadingEllipsis baseFontSize={16} blue />
                  </>
                ) : (
                  "Submit"
                )}
              </FlowOutlineBorderButton>
            </Box>

            <FlowSolidButton
              trackedEventName={
                AnalyticsTrackingEvent.SENDING_NON_ELIGIBLE_REVIEW_TO_BRAND
              }
              trackedAdditionalData={{
                product,
              }}
              disabled={anySubmitting}
              onClick={() => {
                moveNext("SEND_TO_BRAND");
              }}
              sx={{ paddingLeft: "30px", paddingRight: "30px" }}
            >
              {sending ? (
                <>
                  Sending
                  <ButtonLoadingEllipsis baseFontSize={16} />
                </>
              ) : (
                `Send to ${product?.brandName ?? "brand"}`
              )}
            </FlowSolidButton>
          </FlowActionButtonsGroup>
        ) : (
          <FlowActionButtonsGroup>
            <FlowSolidButtonGrey onClick={moveBack}>Back</FlowSolidButtonGrey>
            <FlowSolidButton
              onClick={() => {
                moveNext("SUBMIT");
              }}
              disabled={anySubmitting}
              style={{ paddingLeft: 30, paddingRight: 30 }}
            >
              {submitting ? (
                <>
                  Submitting
                  <ButtonLoadingEllipsis baseFontSize={16} />
                </>
              ) : (
                "Submit review"
              )}
            </FlowSolidButton>
          </FlowActionButtonsGroup>
        )}
      </ReviewQuestionContainer>
    </FlowContainer>
  );
};

export default Summary;
